import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerOrchestratorService from 'services/partnerOrchestratorService';
import { RevisionDetail } from 'views/RevisionHistory/RevisionDtos';

export const useFetchPartnerComparison = (techId: string, oldVersion: number | null, newVersion: number | null) => {
  return useQuery<RevisionDetail[], AxiosError>({
    queryKey: ['useFetchPartnerComparison', techId, oldVersion, newVersion],
    queryFn: () => partnerOrchestratorService.getPartnerComparison(techId, oldVersion, newVersion),
    gcTime: 0,
  });
};
